import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { errorHandler } from '../../../util/error.service'

export async function fetchEntregasParaRoteirizacao(
  statusIds,
  empresasIds,
  considerarEntregasEmSeparacao,
  selectedTp,
) {
  try {
    const url = routes.urlGetEntregasParaRoteirizacao(
      statusIds,
      empresasIds,
      considerarEntregasEmSeparacao,
      selectedTp,
    )
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
